import { render, staticRenderFns } from "./projectSheet.vue?vue&type=template&id=96bc55d2"
import script from "./projectSheet.vue?vue&type=script&lang=js"
export * from "./projectSheet.vue?vue&type=script&lang=js"
import style0 from "./projectSheet.vue?vue&type=style&index=0&id=96bc55d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports